import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { RelatedContent } from 'site-modules/shared/components/editorial/related-content/related-content';
import { RELATED_CONTENT_CONFIG } from 'site-modules/shared/constants/editorial/best';

export const RelatedContentEntry = memo(({ entry, isMobile = false }) => {
  return (
    <div data-tracking-parent={entry.metadata('creative-id').value()} className="mt-1_5">
      <RelatedContent entry={entry} config={RELATED_CONTENT_CONFIG} isMobile={isMobile} titleComponent="h2" />
    </div>
  );
});

RelatedContentEntry.displayName = 'RelatedContentEntry';
RelatedContentEntry.propTypes = {
  entry: PropTypes.shape({
    metadata: PropTypes.func.isRequired,
  }).isRequired,
  isMobile: PropTypes.bool,
};
